<form [formGroup]="optionsFormGroup">
  <mat-form-field
    class="ark-form-field ark-input-full-width ark-input-selector-chips"
    >
    <mat-label class="ark-mat-label">{{ title }}</mat-label>
    <mat-chip-grid
      #chipGrid
      [required]="isValid"
      aria-label="option selection"
      formControlName="optionsControls"
      >
      @for (option of optionsList; track $index) {
        <mat-chip-row
          [removable]="removable"
          (removed)="removeOption(option)"
          >
          <p
            class="ark-tag-text"
          matTooltip="{{
            getOptionText(option).length > 14 ? getOptionText(option) : ''
          }}"
            >
            {{ getOptionText(option) }}
          </p>
          @if (hasEdit) {
            <button (click)="onEditChip(option)">
              <mat-icon class="ark-edit-chip-action">create</mat-icon>
            </button>
          }
          @if (removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-row>
      }
      <input
        class="ark-mat-label"
        appSelectorButton
        [selector]="selectorChips"
        [readonly]="readonly"
        autocomplete="off"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        />
        @if (hasUpdate) {
          <a mat-icon-button matSuffix class="ark-mat-icon-btn">
            <i class="fal fa-sync"></i>
          </a>
        }
      </mat-chip-grid>
      <mat-error>
        {{ 'error.Required' | translate }}
      </mat-error>
      @if (createElement) {
        <mat-hint align="end">
          <a
            class="ark-regular-link GA-message-create-add-topic"
            href="{{ createElement.Link }}"
            rel="noopener"
            target="_blank"
            >
            {{ createElement.Title }}
            <i
              class="fal fa-external-link-square fa-sm GA-message-create-add-topic"
            ></i>
          </a>
        </mat-hint>
      }
    </mat-form-field>
  </form>
  <app-selector
    #selectorChips
    [options]="selectorOptions"
    (selectedChange)="onAddOption($event)"
    [_module]="_module"
    >
  </app-selector>
